module.exports = __webpack_public_path__ + "static/media/yellow.59cb4a76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow.png
// module id = 762
// module chunks = 0